import React from 'react';
import { Icon } from 'venn-ui-kit';
import { Tooltip, TooltipContentWithArrow, TooltipPortal, TooltipTrigger } from '@/components/ui/tooltip';

interface BaseIconWithTooltipProps {
  width: number;
  height: number;
  tooltipText?: string;
  alt?: string;
  className?: string;
  tooltipSide?: 'top' | 'right' | 'bottom' | 'left';
}

type IconWithTooltipProps = BaseIconWithTooltipProps &
  ({ iconImg: string; iconType?: never } | { iconType: string; iconImg?: never });

const IconWithTooltip: React.FC<IconWithTooltipProps> = ({
  iconImg,
  iconType,
  tooltipText,
  width,
  height,
  className,
  alt = '',
  tooltipSide = 'top',
}) => {
  if (!iconType && !iconImg) {
    return null;
  }

  const icon = iconImg ? (
    <img src={iconImg} width={width} height={height} className={className} alt={alt} />
  ) : (
    <Icon type={iconType} />
  );

  // If no tooltip text, render just the icon
  if (!tooltipText) {
    return icon;
  }

  return (
    <Tooltip disableHoverableContent>
      <TooltipTrigger asChild>{icon}</TooltipTrigger>

      <TooltipPortal>
        <TooltipContentWithArrow side={tooltipSide}>{tooltipText}</TooltipContentWithArrow>
      </TooltipPortal>
    </Tooltip>
  );
};

export default IconWithTooltip;
